export default "__VITE_ASSET__Cs4hSodW__"